import { UserRole } from '@academia-apolo/shared-types';
import { ROUTES } from '@/lib/constants';
export const NAVIGATION = [
    // Director
    {
        label: 'Inicio',
        to: ROUTES.DIRECTOR_HOME,
        icon: 'home',
        roles: [UserRole.DIRECTOR],
        end: true,
    },
    {
        label: 'Alumnos',
        to: ROUTES.DIRECTOR_STUDENTS,
        icon: 'users',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Profesores',
        to: ROUTES.DIRECTOR_PROFESSORS,
        icon: 'chalkboard-teacher',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Posibles alumnos',
        to: ROUTES.DIRECTOR_PROSPECTS,
        icon: 'user-plus',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Pagos',
        to: ROUTES.DIRECTOR_PAYMENTS,
        icon: 'credit-card',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Horarios',
        to: ROUTES.DIRECTOR_SCHEDULES,
        icon: 'calendar',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Materiales',
        to: ROUTES.DIRECTOR_MATERIALS,
        icon: 'folder',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Clases grabadas',
        to: ROUTES.DIRECTOR_RECORDINGS,
        icon: 'folder',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Convocatorias',
        to: ROUTES.DIRECTOR_ANNOUNCEMENTS,
        icon: 'megaphone',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Blog',
        to: ROUTES.DIRECTOR_BLOG,
        icon: 'file-text',
        roles: [UserRole.DIRECTOR, UserRole.PROFESSOR],
    },
    {
        label: 'Aprobados',
        to: ROUTES.DIRECTOR_APPROVED,
        icon: 'award',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Solicitudes',
        to: ROUTES.DIRECTOR_REQUESTS,
        icon: 'inbox',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Auditoría',
        to: ROUTES.DIRECTOR_AUDIT,
        icon: 'shield',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Guía codificada',
        to: ROUTES.DIRECTOR_CODIFIED_GUIDE,
        icon: 'book-open',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Código Penal',
        to: ROUTES.DIRECTOR_PENAL_CODE,
        icon: 'scale',
        roles: [UserRole.DIRECTOR],
    },
    {
        label: 'Constitución',
        to: ROUTES.DIRECTOR_CONSTITUTION,
        icon: 'landmark',
        roles: [UserRole.DIRECTOR],
    },
    {
        // Dual role (ADR-009): the director can also teach. Surfaces the professor
        // "Mis clases" page (pass attendance, calendar sync) for role=director.
        label: 'Mis clases',
        to: ROUTES.PROFESSOR_CLASSES,
        icon: 'chalkboard-teacher',
        roles: [UserRole.DIRECTOR],
    },
    // Professor
    {
        label: 'Inicio',
        to: ROUTES.PROFESSOR_HOME,
        icon: 'home',
        roles: [UserRole.PROFESSOR],
        end: true,
    },
    {
        label: 'Mis clases',
        to: ROUTES.PROFESSOR_CLASSES,
        icon: 'calendar',
        roles: [UserRole.PROFESSOR],
    },
    {
        label: 'Mis alumnos',
        to: ROUTES.PROFESSOR_STUDENTS,
        icon: 'users',
        roles: [UserRole.PROFESSOR],
    },
    {
        label: 'Materiales',
        to: ROUTES.PROFESSOR_MATERIALS,
        icon: 'folder',
        roles: [UserRole.PROFESSOR],
    },
    {
        label: 'Cobros',
        to: ROUTES.PROFESSOR_PAYMENTS,
        icon: 'credit-card',
        roles: [UserRole.PROFESSOR],
        requiresCollectPayments: true,
    },
    {
        label: 'Guía codificada',
        to: ROUTES.PROFESSOR_CODIFIED_GUIDE,
        icon: 'book-open',
        roles: [UserRole.PROFESSOR],
    },
    {
        label: 'Código Penal',
        to: ROUTES.PROFESSOR_PENAL_CODE,
        icon: 'scale',
        roles: [UserRole.PROFESSOR],
    },
    {
        label: 'Constitución',
        to: ROUTES.PROFESSOR_CONSTITUTION,
        icon: 'landmark',
        roles: [UserRole.PROFESSOR],
    },
    {
        label: 'Soporte',
        to: ROUTES.PROFESSOR_SUPPORT,
        icon: 'life-buoy',
        roles: [UserRole.PROFESSOR],
    },
    // Student
    {
        label: 'Inicio',
        to: ROUTES.STUDENT_DASHBOARD,
        icon: 'home',
        roles: [UserRole.STUDENT],
        end: true,
    },
    {
        label: 'Horario',
        to: ROUTES.STUDENT_SCHEDULE,
        icon: 'calendar',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Materiales',
        to: ROUTES.STUDENT_MATERIALS,
        icon: 'folder',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Clases grabadas',
        to: ROUTES.STUDENT_RECORDINGS,
        icon: 'folder',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Tests',
        to: ROUTES.STUDENT_TESTS,
        icon: 'book-open',
        roles: [UserRole.STUDENT],
        action: 'student-tests',
    },
    {
        label: 'Asistencia',
        to: ROUTES.STUDENT_ATTENDANCE,
        icon: 'check-square',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Pagos',
        to: ROUTES.STUDENT_PAYMENTS,
        icon: 'credit-card',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Solicitudes',
        to: ROUTES.STUDENT_REQUESTS,
        icon: 'inbox',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Soporte',
        to: ROUTES.STUDENT_SUPPORT,
        icon: 'life-buoy',
        roles: [UserRole.STUDENT],
    },
    {
        label: 'Guía codificada',
        to: ROUTES.STUDENT_CODIFIED_GUIDE,
        icon: 'book-open',
        roles: [UserRole.STUDENT],
        oppositions: ['policia_local'],
    },
    {
        label: 'Código Penal',
        to: ROUTES.STUDENT_PENAL_CODE,
        icon: 'scale',
        roles: [UserRole.STUDENT],
        oppositions: ['policia_local', 'policia_nacional'],
    },
    {
        label: 'Constitución',
        to: ROUTES.STUDENT_CONSTITUTION,
        icon: 'landmark',
        roles: [UserRole.STUDENT],
        oppositions: ['policia_local', 'policia_nacional'],
    },
    // Support console
    {
        label: 'Incidencias',
        to: ROUTES.SUPPORT_INBOX,
        icon: 'life-buoy',
        roles: [UserRole.SUPPORT],
        end: true,
    },
];
export function getNavigationForRole(role, opposition, canCollectPayments = false) {
    return NAVIGATION.filter((item) => {
        if (!item.roles.includes(role))
            return false;
        if (item.oppositions && (!opposition || !item.oppositions.includes(opposition)))
            return false;
        if (item.requiresCollectPayments && !canCollectPayments)
            return false;
        return true;
    });
}
//# sourceMappingURL=navigation.js.map